export default __webpack_public_path__ + "static/bulb-02-232e430ea7038d1ceee996ce4019dec2.svg";